const size = {
  0: '0px',
  10: '1px',
  20: '2px',
  30: '4px',
  40: '8px',
} as const

export default size
